export default __webpack_public_path__ + "static/media/Partner.f39f189f.svg";